import { Card, Col, Row } from 'react-bootstrap';
import { Button } from 'appkit-react';
import { useHistory } from 'react-router-dom';

import '../styles/accountConfirm.scss';

const appTitle = process.env.REACT_APP_TITLE;

const AccountConfirm = ({ userData }) => {
    const welcomeMessage = `Welcome to ${appTitle}`;
    const history = useHistory();
    return (
        <div className="true-comply-account-confirm-container">
            <h4 style={{ textAlign: 'center', color: '#474646' }}>
                {welcomeMessage}
            </h4>
            <br />
            <h6 style={{ textAlign: 'center', color: '#474646' }}>
                You are already registered with us!
            </h6>
            <h6 style={{ textAlign: 'center', color: '#474646' }}>
                Confirm your PwC product account information
            </h6>
            <div className="true-comply-account-confirm_card">
                <Card style={{ width: '30rem' }}>
                    <Card.Body>
                        <Col>
                            <Row>
                                <div className="true-comply-account-confirm_card_text">
                                    <strong>Email:</strong>
                                    <p>{userData.email}</p>
                                </div>
                            </Row>
                            <Row>
                                <div className="true-comply-account-confirm_card_text">
                                    <strong>Name:</strong>
                                    <p>{`${userData.firstName} ${userData.lastName}`}</p>
                                </div>
                            </Row>
                            <Row>
                                <div className="true-comply-account-confirm_card_text">
                                    <strong>Phone Number:</strong>
                                    <p>{userData.mobileNumber}</p>
                                </div>
                            </Row>
                        </Col>
                    </Card.Body>
                </Card>
            </div>
            <div className="true-comply-account-confirm_button">
                <Button size="lg" kind="primary" onClick={() => history.push('/login')}>CONTINUE</Button>
                {/* <div className="true-comply-account-confirm_span">
                    Not you?
                    <span className="red">Contact us</span>
                </div> */}
            </div>
        </div>
    );
};

export default AccountConfirm;
